// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1MBva","col":"styles_col__3Zt5Q","fulfillmentStatus":"styles_fulfillmentStatus__Xr-Rf","emailCol":"styles_emailCol__1uBPg"};